const comBgVideo = (() => {

  const jsComSecBg = (document.getElementById("jsComSecBg") != null);
  if (jsComSecBg) {



    let jsComSecBg = document.getElementById('jsComSecBg');
    let video = jsComSecBg.querySelector('.js-video');

    let sW = window.innerWidth;

    if (sW > 750) {

      video.load();

      //読み込み完了
      video.addEventListener('loadeddata', function () {
        video.play();
      })
      //再生可能
      video.addEventListener('canplay', function () {
        video.play();
      })

      video.play();

    }



  }
})();
export default comBgVideo;